import { createReducer } from '@reduxjs/toolkit';
import type { SvpAssetAdditional } from '@vgtv/api-client/lib/svp_asset';

import type { ServerTime } from '../../helpers/serverTime';

import {
  clearCurrentlyPlayingAsset,
  setCurrentlyPlayingAsset,
  setFavouritesPopupVisibility,
  setIsHeaderSticky,
  setParentalControlsManagerVisibility,
  setServerTime,
} from './actions';

export * from './selectors';

export interface UIState {
  parentalControlsManagerVisible: boolean;
  favouritesPopupVisible: boolean;
  serverTime: ServerTime;
  currentlyPlayingAsset: SvpAssetAdditional | null;
  isHeaderSticky: boolean;
}

const initialState: UIState = {
  parentalControlsManagerVisible: false,
  favouritesPopupVisible: false,
  serverTime: {
    time: Date.now() / 1000,
    receivedAt: Date.now() / 1000,
  },
  currentlyPlayingAsset: null,
  isHeaderSticky: false,
};

const uiReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(setParentalControlsManagerVisibility, (state, action) => {
      state.parentalControlsManagerVisible = action.payload;
    })
    .addCase(setFavouritesPopupVisibility, (state, action) => {
      state.favouritesPopupVisible = action.payload;
    })
    .addCase(setServerTime, (state, action) => {
      state.serverTime = action.payload;
    })
    .addCase(setCurrentlyPlayingAsset, (state, action) => {
      state.currentlyPlayingAsset = action.payload;
    })
    .addCase(clearCurrentlyPlayingAsset, (state) => {
      state.currentlyPlayingAsset = null;
    })
    .addCase(setIsHeaderSticky, (state, action) => {
      state.isHeaderSticky = action.payload;
    })
);

export { uiReducer };
